/**
 * Product Metafields - Shopify 2.0 Component
 * Fetches metafields via Product JSON endpoint
 */

class ProductMetafields extends HTMLElement {
  constructor() {
    super();
    this.productHandle = this.dataset.productHandle;
    this.loadMetafields();
  }

  async loadMetafields() {
    // Wait a bit for Liquid to render metafields first
    // Then clean up empty items
    setTimeout(() => {
      this.cleanupEmptyItems();
    }, 100);
  }

  cleanupEmptyItems() {
    // Remove empty metafield items and clean up formatting
    const items = this.querySelectorAll('.metafield__item');
    let removedCount = 0;
    
    items.forEach(item => {
      const value = item.querySelector('.metafield__value');
      const label = item.querySelector('.metafield__label');
      
      if (value) {
        // Clean up array formatting: remove brackets and quotes
        let textContent = value.textContent.trim();
        
        // Remove square brackets and quotes
        textContent = textContent
          .replace(/\[/g, '') // Remove all opening brackets
          .replace(/\]/g, '') // Remove all closing brackets
          .replace(/"/g, '') // Remove all quotes
          .replace(/,/g, ', ') // Ensure spaces after commas
          .trim();
        
        // Only update if we have text nodes (not HTML content like images/links)
        if (!value.querySelector('img') && !value.querySelector('a') && !value.querySelector('pre')) {
          value.textContent = textContent;
        }
      }
      
      // Check if value is empty or only contains whitespace
      const hasValue = value && (
        value.textContent.trim().length > 0 || 
        value.querySelector('img') || 
        value.querySelector('a') ||
        value.querySelector('pre')
      );
      
      if (!hasValue) {
        item.remove();
        removedCount++;
      }
    });
    
    // Hide component if no items remain
    const remainingItems = this.querySelectorAll('.metafield__item');
    if (remainingItems.length === 0) {
      this.style.display = 'none';
      console.log('ProductMetafields: No metafields to display, hiding component');
    } else {
      console.log(`ProductMetafields: Displaying ${remainingItems.length} metafields (removed ${removedCount} empty items)`);
    }
    
    this.classList.add('metafields-loaded');
  }
}

customElements.define('product-metafields', ProductMetafields);

